/**
 * Where an employee's day went after the punch-in: back to the office, out to
 * a site, on to another site. The server sends them oldest first on each
 * attendance row (`moves`).
 */
export const MOVE_LABELS = {
  OFFICE: 'Back at office',
  SITE: 'At a site'
};

/** One line per move, for a register cell or a review card. */
export function moveLines(moves, formatTime) {
  return (Array.isArray(moves) ? moves : []).map((m) => ({
    id: m.id,
    mode: m.mode,
    time: formatTime(m.moved_at),
    label: MOVE_LABELS[m.mode] ?? m.mode,
    detail: [m.office?.name, m.note].filter(Boolean).join(' · ')
  }));
}

/** Map pins for the moves, to sit between the punch-in and punch-out pins. */
export function movePoints(moves, formatTime) {
  return (Array.isArray(moves) ? moves : [])
    .filter((m) => m.lat != null && m.lng != null)
    .map((m) => ({
      lat: m.lat,
      lng: m.lng,
      accuracy_m: m.accuracy_m,
      label: MOVE_LABELS[m.mode] ?? m.mode,
      time: formatTime(m.moved_at),
      kind: 'MOVE'
    }));
}
